<template>
  <div class="container">
    <div class="title">
      <span
        ><i class="iconfont icon-fanhui-" @click="_tobackPage"></i>
        问卷调查</span
      >
    </div>
    <div class="body">
      <div class="bodyTop">
        <div
          class="form"
          v-for="(item, index) in asks[0].titleArray"
          :key="index"
        >
          <div class="ask">{{ index + 1 }}、{{ item.t_name }}</div>
          <el-radio-group v-model="item.selected">
            <el-radio
              v-for="(item1, index1) in item.t_options"
              :key="index1"
              :value="index1"
              >{{ item1 }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="btn">
        <el-button color="#1242fc" @click="_submitAnswer" style="width: 150px"
          >提交</el-button
        >
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      v-model="dialogFormVisible"
      style="margin-top: 30vh; border-radius: 10px"
      title="填写个人信息"
      width="350"
    >
      <el-form :model="form">
        <el-form-item label="姓名" :label-width="formLabelWidth">

          <div class="dis-row-d">
          <el-input v-model="form.r_name" autocomplete="off" :disabled="nameDisabled"/>
          <span style="margin-left: 10px;min-width: 40px;">匿名</span>
          <el-switch
            v-model="isNiming"
            inline-prompt
            active-text="是"
            inactive-text="否"
            @change="_changeNiming"
          />
          </div>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.r_phone" autocomplete="off" />
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth" class="aligned-label">
          <el-radio-group v-model="form.R_GENDER" style="display: inline;">
            <el-radio
              :value="0"
              size="large"
              fill="#1242fc"
              text-color="#1242fc"
              >男</el-radio
            >
            <el-radio :value="1" size="large">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄" :label-width="formLabelWidth">
          <el-input v-model="form.R_AGE" autocomplete="off" type="number"/>
        </el-form-item>
        <el-form-item label="是否结婚" :label-width="formLabelWidth" class="aligned-label">
          <el-radio-group v-model="form.R_MARRIED" style="display: inline;">
            <el-radio
              :value="0"
              size="large"
              fill="#1242fc"
              text-color="#1242fc"
              >否</el-radio
            >
            <el-radio :value="1" size="large">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer" style="text-align: center">
          <el-button
            color="#1242fc"
            style="width: 230px; justify-content: center"
            @click="_submitInfo"
          >
            提交
          </el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      v-model="failSubmit"
      style="margin-top: 30vh; border-radius: 10px"
      width="350"
      center
    >
      <span> 问卷还未答完，请继续作答！ </span>
      <template #footer>
        <div class="dialog-footer">
          <el-button
            @click="failSubmit = false"
            color="#1242fc"
            style="width: 230px; justify-content: center"
            >确定</el-button
          >
        </div>
      </template>
    </el-dialog>
    <el-dialog
  v-model="resultDialogVisible"
  style="margin-top: 30vh; border-radius: 10px"
  title="答题结果"
  width="350"
  center
>
  <span> 答对 {{ correctCount }} 道题，答错 {{ wrongCount }} 道题 </span>
  <template #footer>
    <div class="dialog-footer">
      <el-button
        @click="_tobackPage"
        color="#1242fc"
        style="width: 230px; justify-content: center"
      >
        确定
      </el-button>
    </div>
  </template>
</el-dialog>
  </div>
</template>

<script>
/* eslint-disable */ 
import http from '@/util/http'
import { ElMessage } from 'element-plus'

export default {
  name: 'questions',
  data() {
    return {
      isNiming:false,
      nameDisabled:false,
      oldName: '',
      dialogFormVisible: false,
      failSubmit: false,
      formLabelWidth: '70px',
      resultDialogVisible: false, // 新增
      correctCount: 0, // 新增
      wrongCount: 0, // 新增
      form: {
        r_name: '',
        r_phone: '',
        R_GENDER: undefined,
        R_AGE: undefined,
        R_MARRIED: undefined
      },
      asks: [
        {
          s_answer_status: 1,
          s_creation_time: '2024-04-23 15:03:32',
          s_delete_flag: 0,
          s_id: 437871128954937340,
          s_id_str: '437871128954937344',
          s_name: '问卷名字',
          s_updated_time: '2024-04-23 00:00:00',
          title: [],
          titleArray: []
        }
      ]
    }
  },
  mounted() {
    this._getquestions()
  },
  methods: {
    isInteger(str) {
     const regPos = /^\d+$/; // 非负整数
     const regNeg = /^-\d+$/; // 负整数
     return regPos.test(str) || regNeg.test(str);
    },
    _changeNiming(e){
      this.nameDisabled = e
      if (e) {
        this.oldName = this.form.r_name
        this.form.r_name = '匿名'
      } else {
        this.form.r_name = this.oldName
      }
    },
    _tobackPage() {
      this.$router.go(-1)
    },
    _getquestions() {
      http.get('survey/').then(res => {
        if (res.code == 200) {
          for (const key in res.data) {
            for (const keyChild in res.data[key].titleArray) {
              // console.log(res.data.data[key][keyChild].t_options)
              res.data[key].titleArray[keyChild].t_options = JSON.parse(
                res.data[key].titleArray[keyChild].t_options
              )
              res.data[key].titleArray[keyChild].selected = undefined
            }
          }
          this.asks = res.data
        }
      })
    },
    _submitInfo() {
  if (!this.form.r_name || !this.form.r_phone) {
    // 姓名手机号有一个为空就error
    ElMessage.warning('请填写完整信息')
    return
  }
  const data = []
  for (const i in this.asks[0].titleArray) {
    if (!this.asks[0].titleArray[i].selected) {
      ElMessage.warning('请选择答案')
      return
    }
    data.push({
      t_id_str: this.asks[0].titleArray[i].t_id_str,
      t_name: this.asks[0].titleArray[i].t_name,
      answer_name: this.asks[0].titleArray[i].selected,
      answer_id: '',
      t_id: this.asks[0].titleArray[i].t_id
    })
  }

  const queryData = {
    record: {
      s_id: this.asks[0].s_id_str,
      answer_name: 'A',
      t_id: 222222,
      r_name: this.form.r_name,
      r_phone: this.form.r_phone,
      r_gender: this.form.R_GENDER,
      r_age: this.form.R_AGE,
      r_married: this.form.R_MARRIED
    },
    answers: data
  }

  if (!this.isInteger(queryData.record.r_age)) {
    ElMessage.warning('年龄必须为数字')
    return
  }
  http.post('record/info/', queryData).then(res => {
    console.log(res);
    if (res.code == 200) {
      // 假设后端返回的数据结构为 { noNum: 3, yesNum: 2 }
      const { noNum, yesNum } = res.data;
      this._showResult(yesNum, noNum); // 更新结果
      this.dialogFormVisible = false
      ElMessage.success('提交成功')
    } else {
      ElMessage.error(res.description)
    }
  })
},

    _submitAnswer() {
      this.dialogFormVisible = true
    },
    _showResult(correctCount, wrongCount) {
    this.correctCount = correctCount
    this.wrongCount = wrongCount
    this.resultDialogVisible = true
  },
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  width: 100%;
  height: 70px;
  background-color: #1242fc;
  color: #fff;
  font-size: 18px;
  line-height: 70px;
  text-align: center;
}

.title i {
  float: left;
  margin-left: 10px;
  position: relative;
}

.title span {
  width: 100%;
  position: absolute;
  top: 12px;
  left: 1px;
}

.body {
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bodyTop {
  height: 85%;
  margin: 20px 0;
  overflow: hidden;
  overflow-y: scroll;
  /* background-color: yellow; */
}

.form {
  width: 350px;
  margin-top: 10px;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
}

.el-dialog--center .el-dialog__body {
  text-align: center;
}

.el-dialog__body {
  font-size: 18px !important;
  color: #1242fc !important;
}

.el-radio-group {
  display: flex;
  flex-direction: column;
  /* justify-content: flex-start; */
  align-items: flex-start;
}

.form .ask {
  /* width: 50px; */
  min-height: 20px;
  /* background-color: pink; */
}

.el-radio {
}

:deep() .el-radio__input.is-checked .el-radio__inner {
  background-color: #1242fc !important;
  border-color: #1242fc !important;
}

:deep() .el-radio__input.is-checked + .el-radio__label {
  color: #1242fc !important;
}

.aligned-label {
  display: flex;
  align-items: center;
}

.inline-radios {
     display: flex;
     gap: 10px; /* 可以根据需要调整间距 */
}

.dis-row-d {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
</style>
